module.exports = __webpack_public_path__ + "static/media/Regulamento_aprovado_pela_SECAP_1.f7046d81.pdf";